<template>
  <v-app id="app">
    <Navigation :login="login" :logout="logout" />
    <AppBar />
    <v-snackbar
      v-model="$store.state.snackbar.isSnackBarShown"
      :timeout="6000"
      bottom
      :color="$store.state.snackbar.color"
      class="dark"
    >
      {{ $store.state.snackbar.text }}
      <v-btn
        @click="$store.state.snackbar.isSnackBarShown = false"
        class="font-weight-bold"
        dark
        text
        >Close</v-btn
      >
    </v-snackbar>
    <v-main style="padding-top: 75px !important">
      <router-view />
    </v-main>
    <AppConfirmDialog />
    <AppLanguageMenu />
    <AppGlobalSpinner v-if="$store.state.showSpinner" />
    <AppErrorCard />

    <confirm-dialog />

    <template v-if="$store.state.auth.isLoggedIn">
      <document-form-dialog />
      <organization-info-dialog />
    </template>

    <v-fab-transition>
      <v-btn
        v-show="!$store.state.ui.isScrollToButtonHidden"
        color="pink"
        fab
        dark
        medium
        fixed
        bottom
        right
        @click="scrollToTop"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
// import VueCookies from 'vue-cookies'
// import CheckOrganizationWrapper from './services/CheckOrganizationWrapper'
// import User from './services/User'
// import jwt from 'jwt-decode'
// import ErrorParser from '@/services/ErrorParser.js'
import AppConfirmDialog from '@/components/ui/AppConfirmDialog'
import AppLanguageMenu from '@/components/ui/AppLanguageMenu'
import AppGlobalSpinner from '@/components/ui/AppGlobalSpinner'
import AppErrorCard from '@/components/ui/AppErrorCard'
import AppBar from '@/components/layout/AppBar'
import Navigation from '@/components/layout/Navigation'
import { Auth } from 'aws-amplify'
import ConfirmDialog from '@/components/GlobalDialogs/ConfirmDialog'

export default {
  name: 'App',

  components: {
    OrganizationInfoDialog: () => import('@/components/GlobalDialogs/OrganizationInfoDialog'),
    DocumentFormDialog: () => import('@/components/GlobalDialogs/DocumentFormDialog'),
    ConfirmDialog,
    AppConfirmDialog,
    AppLanguageMenu,
    AppGlobalSpinner,
    Navigation,
    AppErrorCard,
    AppBar,
  },

  created() {
    this.refreshSession()
    if (this.$store.state.auth.isLoggedIn) {
      this.$store.dispatch('getStarredTendersIds');
      this.$store.dispatch('getUserProfile');
      this.$store.dispatch('auth/getOrganization');
    }
  },

  // created() {
  //     CheckOrganizationWrapper.check(this)
  //     const expiredTimeOfTokenId = jwt(VueCookies.get('token_id')).exp
  //     const nowInSeconds = Date.now() / 1000
  //     const diffOfExpiredAndNow = expiredTimeOfTokenId - nowInSeconds

  //     setTimeout(() => {
  //         this.refresfToken()
  //     }, diffOfExpiredAndNow * 1000 - 30000)

  //     if (this.isMobile()) {
  //         this.$store.state.isMobile = true
  //     }
  //     if (VueCookies.get('token_id')) {
  //         this.$store.commit('login')
  //         localStorage.setItem('login', true)
  //     }
  //     this.parseLanguageForUser()
  // },

  methods: {
    scrollToTop() {
      window.focus()
      window.scrollTo(0, 0)
    },
    login() {
      this.$store.commit('navigation', false)
      this.$router.push({ name: 'login' })
    },
    logout() {
      this.$store.dispatch('auth/signOut')
    },
    setLocale(e) {
      this.$store.commit('setLocale', e)
      localStorage.setItem('locale', e)
      this.$language.current = e
    },
    parseLanguageForUser() {
      this.$store.commit('setLocale', 'en')
      // let locale = localStorage.getItem('locale')
      // if (locale) {
      //     this.$store.commit('setLocale', locale)
      //     this.$language.current = locale
      // } else {
      //     let lang = window.navigator.language || navigator.userLanguage
      //     if (lang === 'uk-UA' || lang === 'uk') {
      //         this.$language.current = 'ua'
      //         this.$store.commit('setLocale', 'ua')
      //         localStorage.setItem('locale', 'ua')
      //     } else if (lang === 'en-US' || lang === 'en') {
      //         this.$language.current = 'en'
      //         this.$store.commit('setLocale', 'en')
      //         localStorage.setItem('locale', 'en')
      //     } else {
      //         this.$language.current = 'ua'
      //         this.$store.commit('setLocale', 'ua')
      //         localStorage.setItem('locale', 'ua')
      //     }
      // }
    },
    closeSnackBar() {
      this.$store.commit('closeSnackBar')
    },
    isMobile() {
      return screen.width <= 760
    },
    async refreshSession() {
      try {
        const currentUser = await Auth.currentAuthenticatedUser()

        const currentSession = await Auth.currentSession()

        currentUser.refreshSession(currentSession.refreshToken, () => {})
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style>
@font-face {
  font-family: 'Montserrat';
  src: url('./assets/fonts/Montserrat/Montserrat-Regular.ttf');
}
@font-face {
  font-family: 'Montserrat-Medium';
  src: url('./assets/fonts/Montserrat/Montserrat-Medium.ttf');
}
@font-face {
  font-family: 'Montserrat-SemiBold';
  src: url('./assets/fonts/Montserrat/Montserrat-Bold.ttf');
}
@font-face {
  font-family: 'Ubuntu-Medium';
  src: url('./assets/fonts/Ubuntu/Ubuntu-Medium.ttf');
}
@font-face {
  font-family: 'Ubuntu';
  src: url('./assets/fonts/Ubuntu/Ubuntu-Regular.ttf');
}
.cursor-pointer {
  cursor: pointer;
}
#contact-phone:focus,
#contact-phone .dropdown:focus,
#contact-phone ul:focus,
.dropdown.open,
.vue-tel-input:focus-within,
#contact-phone:focus-within {
  outline: none !important;
  box-shadow: none;
}
#app {
  background: rgb(236, 236, 236);
  font-family: 'Montserrat-Medium', sans-serif;
}
h2 {
  font-family: 'Montserrat-SemiBold', sans-serif;
}
.v-application p {
  margin-bottom: 10px;
}
::-webkit-scrollbar {
  display: none;
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  display: none;
  background: #ff0000;
}
.left-bar,
.right-bar {
  scrollbar-width: none;
  overflow-y: scroll;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.left-bar::-webkit-scrollbar,
.right-bar::-webkit-scrollbar {
  display: none;
}
.v-text-field__prefix {
  color: #1976d2 !important;
}
.v-input__control .v-text-field__suffix {
  color: #1976d2 !important;
  opacity: 0.7;
}

.highlighted {
  background: lightgray;
}

.organization-table .v-data-table-header-mobile__wrapper .v-select {
  margin-left: 20px;
}

.v-breadcrumbs li div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.dialog-publish-notification {
  max-width: 420px !important;
}

.v-breadcrumbs li:nth-child(even) {
  padding: 0 6px !important;
}

.v-overlay--active {
  z-index: 100 !important;
}

.v-navigation-drawer--temporary,
.v-navigation-drawer--is-mobile {
  z-index: 9999;
}

.organization-info .v-text-field__prefix,
.user-info .v-text-field__prefix {
  color: rgba(0, 0, 0, 0.38) !important;
}

.organization-info .theme--light.v-input--is-disabled input,
.user-info .theme--light.v-input--is-disabled input,
.profile-info .theme--light.v-input--is-disabled input {
  color: #1976d2 !important;
  opacity: 0.7;
}

#searchMenu .v-input__append-outer .primary--text {
  color: rgba(0, 0, 0, 0.54) !important;
}

.p-relative {
  position: relative!important;
}
</style>
